var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.config.class},[(_vm.config.component)?[_c(_vm.config.component,_vm._b({tag:"component"},'component',_vm.config.componentConfig,false),[_vm._v(" "+_vm._s(_vm.formattedValue)+" ")])]:[_vm._v(" "+_vm._s(_vm.formattedValue)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }